<template>
  <section
    class="intro-text-box no-flicker"
    :class="{ active: active }"
    :style="{
      bottom: textBox.position.bottom + '%',
      left: textBox.position.left + '%',
      width: scale > 1 ? 7 + 'vw' : null,
      height: scale > 1 ? 4.2 + 'vw' : null
    }"
  >
    <div class="intro-text-box__exit-area">
      <div class="intro-text-box__exit-area__intro-text-box-button" @click="endAnimation">
        <p
          class="font intro-text-box__exit-area__intro-text-box-button__exit"
          :style="{ fontSize: scale > 1 ? 0.3 + 'vw' : null }"
        >EXIT</p>
        <img class="intro-text-box__exit-area__intro-text-box-button__icon" :src="exitIcon" alt="exit button" />
      </div>
    </div>
    <div class="intro-text-box__text-area">
      <div class="intro-text-box__text-area__wrapper">
        <div v-if="textBox.icon" class="intro-text-box__text-area__wrapper__icon">
          <img :src="textBox.icon" alt />
        </div>
        <div
          class="font intro-text-box__text-area__wrapper__text"
          :class="{ 'full-width': !textBox.icon, center: !textBox.icon }"
        >
          <p
            id="textBoxText"
            :style="{ fontSize: scale > 1 ? 0.3 + 'vw' : null }"
            v-html="textBox.text"
          ></p>
        </div>
      </div>
    </div>

    <div class="intro-text-box__next-area">
      <div class="intro-text-box__next-area__intro-text-box-button">
        <p
          :style="{ fontSize: scale > 1 ? 0.3 + 'vw' : null }"
          class="font intro-text-box__next-area__intro-text-box-button__next"
        >{{ textBox.title.toUpperCase() }}</p>
      </div>
      <div
        class="intro-text-box__next-area__intro-text-box-button-continue"
        @click="startAnimation"
      >
        <p
          :style="{ fontSize: scale > 1 ? 0.3 + 'vw' : null }"
          class="font--semibold intro-text-box__next-area__intro-text-box-button-continue__next"
        >CONTINUE</p>
        <img
          class="intro-text-box__next-area__intro-text-box-button-continue__icon"
          :src="nextArrowIcon"
          alt
        />
      </div>
    </div>
  </section>
</template>

<script>
import nextArrowIcon from "@/assets/text-box-accents/next-arrow.svg";
import exitIcon from "@/assets/text-box-accents/exit-icon.svg";
import goButton from "@/assets/text-box-accents/go-button.svg";

import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "intro-text-box",
  props: [
    "textBox",
    "onClose",
    "next",
    "updated",
    "continueAnimation",
    "lastTextBox",
    "previousProgress",
    "animationProgress",
    "panAndZoomTo",
    "active",
    "triggerPlay"
  ],
  data() {
    return {
      nextArrowIcon,
      exitIcon,
      goButton,
      i: 0,
      typeTimeOuts: [],
      progressMotion: this.previousProgress
    };
  },
  computed: {
    ...mapState({
      animationFrame: state => state.moduleMacroAnimations.animationFrame,
      totalWaitTime: state => state.moduleMacroAnimations.totalWaitTime,
      waitProgress: state => state.moduleMacroAnimations.waitProgress,
      voiceOver: state => state.audio.voiceOver,
      scale: state => state.panZoom.scale
    })
  },
  methods: {
    ...mapMutations([
      "updateWaitProgress",
      "updateTotalWaitTime",
      "setVoiceOver",
      "setIntroTextbox",
      "updateIsZoomed",
      "updateIsNotZoomedHighlight",
      "setDelay",
      "updateShowAmbientAnimations",
      "updateCurrentAnimation"
    ]),
    startAnimation() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Played",
        eventLabel: "PLAYED: " + this.textBox.title,
        eventValue: 1
      });
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.setDelay(true);
      this.updateIsZoomed(true);
      this.updateIsNotZoomedHighlight(false);
      if (process.env.VUE_APP_TOUCHPOINT_DATA_SET === "wall") {
        this.panAndZoomTo("mainMapWrapper", this.textBox.ref);
      } else {
        this.triggerPlay();
      }
    },
    endAnimation() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Canceled Selection",
        eventLabel: "CANCELED_INTRO_TEXTBOX: " + this.textBox.title,
        eventValue: 1
      });
      this.updateShowAmbientAnimations(true);
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.updateIsNotZoomedHighlight(false);
      this.setIntroTextbox(undefined);
      this.updateWaitProgress(0);
      this.onClose();
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";
.intro-text-box {
  position: absolute;
  opacity: 1;
  transform: scale(1.8);
  width: 10.5vw;
  height: 6vw;
  &__exit-area {
    position: relative;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 15%;
    &__intro-text-box-button {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__exit {
        color: $color-white;
        font-size: 0.4vw;
        margin-right: 0.3vw;
      }
      &__icon {
        height: 0.55vw;
        width: 0.55vw;
        margin-right: 0.3vw;
      }
    }
  }
  &__text-area {
    position: relative;
    width: 100%;
    height: 40%;
    background-color: $color-white;
    &__wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 2%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      &__icon {
        width: 16%;
        height: 100%;
        margin-top: 2%;
        margin-left: 1%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &__text {
        padding: 0.3% 0;
        width: 81%;
        height: 100%;
        line-height: 0.5vw;
        font-size: 0.4vw;
        margin-left: 2%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
      }
    }
  }
  &__progress-bar {
    position: relative;

    width: 100%;
    height: 2%;
    min-height: 2px;
    background-color: $color-blue;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    &__animation-progress {
      z-index: 10;
      width: 80%;
      height: 100%;
      &__progress {
        height: 100%;
        width: 100%;
        background-color: $color-lime;
        transform-origin: left;
        transform: scaleX(0);
      }
    }
    &__pause-progress {
      z-index: 10;
      width: 20%;
      height: 100%;
      &__progress {
        height: 100%;
        width: 100%;
        background-color: $color-lime;
        transform-origin: left;
        transform: scaleX(0);
      }
    }
  }
  &__next-area {
    height: 19%;
    display: flex;
    justify-content: space-between;
    background-color: $color-black-transparent;
    &__intro-text-box-button {
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      &__next {
        color: $color-lime-bright;
        font-size: 0.4vw;
        margin-left: 0.3vw;
      }
    }
    &__intro-text-box-button-continue {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__next {
        color: $color-lime-bright;
        font-size: 0.4vw;
        margin-right: 0.3vw;
      }
      &__icon {
        height: 0.55vw;
        width: 0.55vw;
        margin-right: 0.3vw;
      }
    }
  }
  &__pointer-area {
    position: relative;
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
  &__go-button-area-wrapper {
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-content: center;
    align-items: center;
    &__go-button-area {
      position: absolute;
      width: 5vw;
      height: 1vw;
      transform: translateX(0);
      cursor: pointer;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      align-content: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 0.5vw solid transparent;
  border-right: 0.5vw solid transparent;
  border-top: 0.4vw solid rgba(black, 0.5);
}
.arrow-right {
  justify-content: flex-end;
}

.arrow-right-margin {
  margin-right: 0.5vw;
}
.active {
  z-index: 200;
}

.full-width {
  width: 100%;
}

.center {
  justify-content: center;
}
</style>
